/**
 * Generate a URL-safe slug from a name.
 * Matches backend OnboardingService._generate_slug() logic.
 */
export function generateSlug(name: string): string {
  return name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanum with hyphens
    .replace(/-+/g, '-') // Collapse double hyphens
    .replace(/^-|-$/g, '') // Trim edges
    || 'org'
}
